$(document).ready(function() {
    var $logoTrack = $('.logo-track');
    var $logos = $('.logo');

    // Duplicate the logos to create an infinite loop
    $logoTrack.append($logos.clone());

    // Optional: Adjust speed dynamically
    $logoTrack.css('animation-duration', '30s'); // Slower speed, increase the duration for a slower scroll
});
$(document).ready(function() {
    console.log('JavaScript loaded successfully');
});